import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';
import { Config } from '@generated/models';
import { MainSidebarMenuComponent } from './main-sidebar-menu.component';

@Component({
  selector: 'app-main-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MainSidebarMenuComponent, DatePipe],
  template: ` @let _isOpen = isOpen();
    <div class="flex h-full items-start">
      <div class="flex flex-col h-full bg-soe-dark-gray rounded-xl" [class.w-60]="_isOpen" [class.w-18]="!_isOpen">
        <div class="text-white flex justify-start p-3.5">
          <button class="cursor-pointer px-0.5" (click)="isOpen.set(!_isOpen)">
            <i class="pi" [class.pi-angle-double-right]="!_isOpen" [class.pi-angle-double-left]="_isOpen"></i>
          </button>
        </div>
        <app-main-sidebar-menu [collapsed]="!_isOpen" class="flex-1 p-3" />
        @if (_isOpen) {
          <div class="pb-1 text-xs text-white text-center ">
            <div class="flex gap-2 items-center justify-center">
              @let _version = buildVersion();
              <span>Web: {{ _version.web }}</span>
              <span>API: {{ _version.api }}</span>
            </div>
            <div>
              {{ buildDate() | date: 'short' }}
            </div>
          </div>
        }
      </div>
    </div>`,
  styles: ``,
})
export class MainSidebarComponent {
  readonly buildInfo = input.required<{
    api: Config['buildInfo'] | undefined;
    web: { version: string; date: string };
  }>();
  readonly buildVersion = computed(() => {
    const _buildInfo = this.buildInfo();
    return {
      api: _buildInfo.api?.version ?? 'N/A',
      web: _buildInfo.web.version,
    };
  });
  readonly buildDate = computed(() => {
    const _buildInfo = this.buildInfo();
    if (!_buildInfo.api?.date) {
      return _buildInfo.web.date;
    }
    return _buildInfo.api.date > _buildInfo.web.date ? _buildInfo.api.date : _buildInfo.web.date;
  });
  readonly isOpen = signal(true);
}
